export default __webpack_public_path__ + "static/media/random.c25a5aa8.png";